export interface WorkingHours {
  id: string;

  lastModifiedById?: string;
  lastModified?: Date;

  isDefault: boolean;
  weekStartDay: string;

  companyId: string;
  projectId: string;

  mondayStartsAt: string;
  mondayEndsAt: string;
  mondayPauseStartsAt: string;
  mondayPauseEndsAt: string;

  tuesdayStartsAt: string;
  tuesdayEndsAt: string;
  tuesdayPauseStartsAt: string;
  tuesdayPauseEndsAt: string;

  wednesdayStartsAt: string;
  wednesdayEndsAt: string;
  wednesdayPauseStartsAt: string;
  wednesdayPauseEndsAt: string;

  thursdayStartsAt: string;
  thursdayEndsAt: string;
  thursdayPauseStartsAt: string;
  thursdayPauseEndsAt: string;

  fridayStartsAt: string;
  fridayEndsAt: string;
  fridayPauseStartsAt: string;
  fridayPauseEndsAt: string;

  saturdayStartsAt: string;
  saturdayEndsAt: string;
  saturdayPauseStartsAt: string;
  saturdayPauseEndsAt: string;

  sundayStartsAt: string;
  sundayEndsAt: string;
  sundayPauseStartsAt: string;
  sundayPauseEndsAt: string;

  workingHoursPerWeek: string;
  netWorkingHoursPerWeek: string;
}

const timeFieldDescription =
  'Time in "HH:mm" format (e.g., "08:00" or "16:00"). Null or empty string if clearing the value.';

export const workingHoursChatbotFields = {
  mondayStartsAt: { type: 'string', description: timeFieldDescription },
  mondayEndsAt: { type: 'string', description: timeFieldDescription },
  mondayPauseStartsAt: { type: 'string', description: timeFieldDescription },
  mondayPauseEndsAt: { type: 'string', description: timeFieldDescription },

  tuesdayStartsAt: { type: 'string', description: timeFieldDescription },
  tuesdayEndsAt: { type: 'string', description: timeFieldDescription },
  tuesdayPauseStartsAt: { type: 'string', description: timeFieldDescription },
  tuesdayPauseEndsAt: { type: 'string', description: timeFieldDescription },

  wednesdayStartsAt: { type: 'string', description: timeFieldDescription },
  wednesdayEndsAt: { type: 'string', description: timeFieldDescription },
  wednesdayPauseStartsAt: { type: 'string', description: timeFieldDescription },
  wednesdayPauseEndsAt: { type: 'string', description: timeFieldDescription },

  thursdayStartsAt: { type: 'string', description: timeFieldDescription },
  thursdayEndsAt: { type: 'string', description: timeFieldDescription },
  thursdayPauseStartsAt: { type: 'string', description: timeFieldDescription },
  thursdayPauseEndsAt: { type: 'string', description: timeFieldDescription },

  fridayStartsAt: { type: 'string', description: timeFieldDescription },
  fridayEndsAt: { type: 'string', description: timeFieldDescription },
  fridayPauseStartsAt: { type: 'string', description: timeFieldDescription },
  fridayPauseEndsAt: { type: 'string', description: timeFieldDescription },

  saturdayStartsAt: { type: 'string', description: timeFieldDescription },
  saturdayEndsAt: { type: 'string', description: timeFieldDescription },
  saturdayPauseStartsAt: { type: 'string', description: timeFieldDescription },
  saturdayPauseEndsAt: { type: 'string', description: timeFieldDescription },

  sundayStartsAt: { type: 'string', description: timeFieldDescription },
  sundayEndsAt: { type: 'string', description: timeFieldDescription },
  sundayPauseStartsAt: { type: 'string', description: timeFieldDescription },
  sundayPauseEndsAt: { type: 'string', description: timeFieldDescription },
};
